// Arabisch: webteksten van 'Soera's leren' (golf 7). Genderneutraal waar het over een kind gaat;
// de ouder wordt aangesproken zoals in app.ar.ts. POORT: moedertaalreview.
export const appMemorizeAr = {
    title: 'حفظ السور',
    nav: 'الحفظ',
    card: {
        body: 'متابعة السور التي يحفظها أطفالكم. يُسمِّع الطفل، وتستمع أنت فعلًا ثم تختار «تمّ التسميع جيدًا». عندها فقط تُضاف النقاط.',
        question: 'هل تريد المتابعة؟',
        yes: 'نعم',
        notNow: 'لا، ليس الآن',
        notNowDone: 'حسنًا. يمكنك تشغيله من هنا في أي وقت.',
        on: 'مُفعَّل لـ {names}.',
        open: 'إلى صفحة الحفظ',
        settings: 'الإعدادات',
        renewal: 'امنح الموافقة أولًا من جديد في «ما يناسب عائلتنا».',
    },
    wizard: {
        title: 'تشغيل حفظ السور',
        step: 'الخطوة {n} من 4',
        back: 'السابق',
        next: 'التالي',
        done: 'تشغيل',
        who: {
            title: 'من يشارك؟',
            body: 'فعّل من يشارك. الأطفال دون 16 عامًا الذين تقرر عنهم.',
            teen: '{name}: القرار ذاتي. يأتي ذلك لاحقًا.',
            otherFaith: '{name}: اختيار ديني خاص، دون مشاركة.',
            none: 'لا يوجد في العائلة أطفال دون 16 عامًا.',
            pick: 'فعّل طفلًا واحدًا على الأقل.',
            and: 'و',
            joins: 'يشارك',
            paused: 'لا يشارك الآن. يبقى التقدّم محفوظًا.',
            notYet: 'لا يشارك',
            toggle: '{name}: يشارك',
            later: 'التفعيل يطلب أولًا موافقتك لذلك الطفل. الإيقاف يحفظ التقدّم.',
            more: 'هل تريد أن يشارك شخص آخر أيضًا؟',
            choose: 'اختر الأطفال',
            turnedOn: '{name}: يشارك.',
            turnedOff: '{name}: لا يشارك الآن. يبقى التقدّم محفوظًا.',
        },
        naming: {
            title: 'كيف تسمّون السور؟',
            turkish: 'Fâtiha, İhlâs, Kevser',
            arabic: 'الفاتحة، الإخلاص، الكوثر',
            order: 'الترتيب',
            recommended: 'المقترح: الفاتحة ثم الأقصر',
            prayer: 'ترتيب الصلاة: الفاتحة، ثم من الفيل إلى الناس',
        },
        board: {
            title: 'العرض على اللوحة؟',
            body: 'كل من يقف أمام اللوحة يرى هذا عند الطفل المختار.',
            yes: 'نعم، على اللوحة',
            no: 'لا، في التطبيق فقط',
        },
        known: {
            title: 'ماذا يحفظ كل طفل مسبقًا؟',
            body: 'حدّد ما يحفظه الطفل مسبقًا. لا نقاط لذلك ولا احتفال.',
        },
    },
    consent: {
        title: 'الموافقة لـ {name}',
        text: 'نتابع تقدّم {name} في تعلّم السور وحفظها، لعائلتكم فقط. يمكنك سحب ذلك في أي وقت؛ وعندها نحذف تقدّم {name}.',
        check: 'أنا وليّ أمر {name} أو الوصيّ الشرعي، وأوافق على ذلك.',
        textMany: 'نتابع تقدّم {name} في تعلّم السور وحفظها، لعائلتكم فقط. يمكنك سحب ذلك في أي وقت؛ وعندها نحذف تقدّم {name}.',
        checkMany: 'أنا وليّ أمر {name} أو الوصيّ الشرعي، وأوافق على ذلك.',
        give: 'منح الموافقة',
        withdraw: 'سحب الموافقة',
        withdrawConfirm: 'سحب الموافقة لـ {name}؟ يحذف ذلك تقدم {name} فورًا. تبقى النقاط المكتسبة.',
        withdrawn: 'تم سحب الموافقة. حُذف تقدم {name}.',
        given: 'مُنحت الموافقة في {date}.',
        none: 'لا توجد موافقة بعد',
    },
    stage: {
        none: 'لم يبدأ الحفظ بعد',
        learning: 'قيد الحفظ',
        ready: 'طلب التسميع',
        known: 'تمّ الحفظ',
        review: 'مراجعة قصيرة',
    },
    overview: {
        subtitle: 'السور التي يحفظها الأطفال. كل طفل حسب وتيرته.',
        now: 'الآن: {item}',
        nothing: 'لم يبدأ شيء بعد',
        next: 'التالي: {item}',
        allKnown: '{name}: تمّ حفظ القائمة كلها',
        waiting: 'بانتظار التسميع ({count})',
        refresh: 'للمراجعة: {items}',
        list: 'القائمة',
        settings: 'الإعدادات',
        open: 'عرض',
        paused: 'حفظ السور متوقف. الإيقاف لا يحذف شيئًا الآن. بعد 12 شهرًا من الإيقاف يُحذف التقدم.',
        notSet: 'حفظ السور غير مُفعَّل بعد.',
        setUp: 'تشغيل',
        noConsent: 'لا توجد موافقة بعد',
        disabled: 'خارج المشاركة حاليًا',
        selfDecides: 'قرار ذاتي؛ يأتي لاحقًا',
    },
    member: {
        progress: 'تمّ حفظ {x} من {y}',
        orderLearn: 'ترتيب الحفظ',
        orderMushaf: 'ترتيب المصحف',
        menu: 'ماذا تريد أن تفعل بـ {item}؟',
        start: 'البدء',
        ready: 'طلب التسميع',
        approve: 'تمّ التسميع جيدًا',
        practice: 'تمرين قليل بعد',
        markKnown: 'تمّ تسميع هذه',
        baseline: 'كانت محفوظة من قبل',
        refresh: 'مراجعة قصيرة',
        heard: 'تمّ التسميع جيدًا',
        revert: 'اعتُمدت بالخطأ',
        revertConfirm: 'تراجع؟ تعود {item} بعدها إلى «قيد الحفظ».',
        revertPoints: 'تُخصم نقاط {item} ({count}).',
        negative: 'سيصبح رصيد {name} سالبًا. هل تريد التراجع رغم ذلك؟',
        reset: 'حذف',
        resetConfirm: 'حذف {item} لـ {name}؟ تعود بعدها إلى «لم يبدأ الحفظ بعد».',
        confirm: 'نعم',
        cancel: 'لا',
        upto: 'حتى الآية',
        uptoHint: 'في سورة أطول: إلى أي آية وصل حفظ {name}؟',
        uptoSave: 'حفظ',
        uptoClear: 'مسح',
        uptoShort: 'حتى الآية {n}',
        listen: 'الاستماع على Quran.com',
        verses: {
            zero: '{count} آية',
            one: 'آية واحدة',
            two: 'آيتان',
            few: '{count} آيات',
            many: '{count} آية',
            other: '{count} آية',
        },
        points: {
            zero: '{count} نقطة',
            one: 'نقطة واحدة',
            two: 'نقطتان',
            few: '{count} نقاط',
            many: '{count} نقطة',
            other: '{count} نقطة',
        },
        reviewRound: 'جولة مراجعة',
        reviewRoundBody: 'استمع من جديد إلى بعض السور المحفوظة. بلا نقاط، مراجعة قصيرة فقط.',
        reviewRoundEmpty: 'لا شيء للمراجعة الآن.',
        reviewRoundDone: 'انتهت جولة المراجعة.',
        inactive: 'لم تعد في القائمة',
        extra: 'إضافي',
        heardBy: 'الاستماع من',
        heardParent: 'أنا',
        heardTeacher: 'المعلّم (الشيخ، المعلّمة)',
        milestones: 'محطات',
        divider: 'الفاتحة وقصار السور',
        milestone: {
            fatiha: 'تمّ حفظ الفاتحة',
            prayer_set: 'الفاتحة وقصار السور العشر',
            starter_set: 'السور العشرون الأولى',
        },
        done: 'تم الحفظ.',
        childBody: 'اضغط على الزر للبدء أو للتسميع.',
        childStart: 'سأبدأ حفظها',
        childReady: 'حفظتُها',
        childOops: 'تراجع',
        childReadyDone: 'جميل. سيستمع أحد الوالدين قريبًا',
        agedOut: 'من عمر 16 سنة يعود القرار إلى {name}. بعد الضغط على «حفظ» يُمحى تقدّم {name} في حفظ السور، وتبقى النقاط.',
        /** Golf 7 live r1: bevestiging vóór een geboortedatum die een meedoend kind 16+ maakt. */
        agedOutBirth: {
            title: 'حفظ تاريخ الميلاد؟',
            body: 'بتاريخ الميلاد هذا يكون عمر {name} 16 سنة أو أكثر. من سن 16 يقرّر {name} بنفسه: عند الحفظ يُحذف تقدّم {name} في حفظ السور. تبقى النقاط.',
            confirm: 'حفظ وحذف',
        },
    },
    list: {
        body: 'النقاط واحدة لكل الأطفال.',
        rewardsOff: 'المكافآت متوقفة: لا تُمنح نقاط.',
        up: '{item} إلى الأعلى',
        down: '{item} إلى الأسفل',
        drag: 'اسحب للنقل',
        active: 'في القائمة',
        points: 'النقاط',
        presets: 'ترتيب بضغطة واحدة',
        recommended: 'المقترح',
        prayer: 'ترتيب الصلاة',
        more: 'إضافة المزيد',
        moreBody: 'إضافي: آية الكرسي (آية وليست سورة). والسور من 95 إلى 78.',
        add: 'إضافة',
        remove: 'إزالة من القائمة',
        save: 'حفظ القائمة',
        saved: 'تم حفظ القائمة.',
        keptNote: 'تبقى محفوظة لأن فيها تقدمًا.',
    },
    settings: {
        naming: 'الأسماء',
        namingTurkish: 'بالتركية: Fâtiha, İhlâs, Kevser',
        namingArabic: 'بالعربية: الفاتحة، الإخلاص، الكوثر',
        riwaya: 'الرواية',
        hafs: 'حفص',
        warsh: 'ورش',
        warshNote: 'مع ورش لا نعرض أرقام الآيات ولا رابطًا: يختلف العدّ بحسب الطبعة.',
        refresh: 'المراجعة بعد',
        days: '{count} يومًا',
        never: 'أبدًا',
        board: 'العرض على اللوحة',
        boardNote: 'كل من يقف أمام اللوحة يرى هذا عند الطفل المختار.',
        consent: 'الموافقة لكل طفل',
        wipe: 'حذف تقدم الجميع',
        wipeBody: 'يحذف كل التقدم والقائمة والإعدادات، ويسحب الموافقات. تبقى النقاط المكتسبة.',
        wipeConfirm: 'حذف كل شيء؟ لا يمكن التراجع عن ذلك.',
        wiped: 'تم حذف حفظ السور.',
        off: 'إيقاف',
        offNote: 'الإيقاف لا يحذف شيئًا الآن. بعد 12 شهرًا من الإيقاف يُحذف التقدم.',
        on: 'التشغيل من جديد',
        pointsNote: 'بعد الحذف تبقى النقاط المكتسبة. إذا شغّلته لاحقًا من جديد، قد تمنح السورة نقاطًا مرة أخرى.',
        saved: 'تم الحفظ.',
    },
    approvals: {
        title: 'التسميع',
        wants: '{name}: طلب تسميع {item}',
        wantsAgain: '{name}: طلب تسميع {item} من جديد',
        since: 'منذ {time}',
        points: {
            zero: '{count} نقطة مع «تمّ التسميع جيدًا»',
            one: 'نقطة واحدة مع «تمّ التسميع جيدًا»',
            two: 'نقطتان مع «تمّ التسميع جيدًا»',
            few: '{count} نقاط مع «تمّ التسميع جيدًا»',
            many: '{count} نقطة مع «تمّ التسميع جيدًا»',
            other: '{count} نقطة مع «تمّ التسميع جيدًا»',
        },
        approve: 'تمّ التسميع جيدًا',
        practice: 'تمرين قليل بعد',
        heardBy: 'الاستماع من',
        me: 'أنا',
        teacher: 'المعلّم (الشيخ، المعلّمة)',
        already: 'تمّ ذلك من قبل.',
        approved: '{item}: تمّ التسميع.',
        practiced: 'تمرين قليل بعد. يمكن لـ {name} التسميع لاحقًا من جديد.',
        seen: 'رأيته',
        milestone: '{name}: {text}',
    },
    errors: {
        stale_stage: 'تمّ ذلك من قبل.',
        revert_first: 'تراجع أولًا عبر «اعتُمدت بالخطأ».',
        not_eligible: 'هذا الطفل خارج المشاركة (بعد).',
        consent_renewal_required: 'امنح الموافقة أولًا من جديد في «ما يناسب عائلتنا».',
    },
};
//# sourceMappingURL=memorizeApp.ar.js.map